import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { paginationKeys } from '@features/buyer-line-items-pagination/api/keys';
import type { ID } from 'types';

export const useInvalidateLotPages = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (eventId: ID) => queryClient.invalidateQueries({ queryKey: paginationKeys.lotPages(eventId) }),
    [queryClient],
  );
};
